import { TUpdateCredentialProps } from '@commenda/types/src/credential/types';
import { fetcher } from '@commenda/utils';

export async function updateCredential(
  credentialId: string,
  data: TUpdateCredentialProps
) {
  const response = await fetcher(`credentials/${credentialId}`, {
    method: 'POST',
    body: data,
  });

  return response;
}
